import { useCallback, useState } from 'react';

import { Typography } from '@mui/material';
import { useAppDispatch,useAppSelector } from 'app/hooks';
import { DeleteDialog } from 'common/components/deleteDialog/DeleteDialog';
import { setDialogOpen } from 'common/components/deleteDialog/deleteDialogSlice';
import { selectPageInfo, setRows } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { deleteApiKey } from 'common/services/api/ApiKeys/ApiKeys.thunks';
import { DeleteDialogContentProps } from 'common/types/TypeDefs';
import { handleDeleteDialogError } from 'common/utils/errorHandlers';
import { useSnackbar } from 'notistack';

export const ApiKeysDeleteDialogContent = (props: DeleteDialogContentProps<{ value: string }>) => {
    const { title, itemId, editingRow } = props;
    const { value } = editingRow ?? {};
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useAppDispatch();

    const appSuite = useAppSelector(selectPageInfo);
    const [processing, setProcessing] = useState<boolean>(false);

    const successHandler = (): void => {
        dispatch(setDialogOpen(false));
        enqueueSnackbar('API Key has been deleted.', { variant: 'success' });
    };

    const apiKeydeleteCallback = useCallback(() => {
        if (itemId) {
            setProcessing(true);
            const options = {
                id: appSuite?.id ?? '',
                name: itemId.toString()
            };
            dispatch(deleteApiKey(options))
                .unwrap()
                .then((result) => {
                    dispatch(setRows(result.rows));
                    successHandler();
                    setProcessing(false);
                })
                .catch(() => {
                    handleDeleteDialogError('API Key', enqueueSnackbar);
                    setProcessing(false);
                });
        }
    }, [itemId]);

    return (
        <DeleteDialog deleteCallback={apiKeydeleteCallback} title={title} processing={processing}>
            <Typography color="info.light" fontSize='0.9rem' fontWeight='550'>
                API Key Name: <Typography component="span" color="text.primary" fontWeight="400">{itemId}</Typography>
            </Typography>
            <Typography color="info.light" fontSize='0.9rem' fontWeight='550'>
                API Key Value: <Typography component="span" color="text.primary" fontWeight="400">{value}</Typography>
            </Typography>
            <Typography color="info.light" fontSize='0.9rem' fontWeight='550'>
                Application Suite Name: <Typography component="span" color="text.primary" fontWeight="400">{appSuite?.name}</Typography>
            </Typography>
        </DeleteDialog>
    );
};
